import Vue from "vue";
import App from "./App.vue";
import Vuelidate from "vuelidate";

export default function init() {
  const element = document.getElementById("newsletterForm");

  if (element) {
    Vue.config.productionTip = false;
    Vue.use(Vuelidate);

    new Vue({
      render: createElement => {
        const context = {
          props: { ...element.dataset }
        };
        return createElement(App, context);
      }
    }).$mount("#newsletterForm");
  }
}
